module.exports = __webpack_public_path__ + "img/MBT.3eb2cdba.gif";